<template>
  <div class="equipment-records">
    <page-list-container 
      :total="total" 
      :pageSize="pageSize" 
      :inputCurrentPage="currentPage"
      @onPageChange="onPageChange" 
      @onSizeChange="onSizeChange"
    >
      <div class="equipment-records-table">
        <el-table :data="dataArray" stripe style="width: 100%">
          <el-table-column prop="targetName" label="SN" width="140" />
          <el-table-column prop="operatorName" label="操作人" width="80" />
          <el-table-column prop="operationTime" label="操作时间" width="180" />
          <el-table-column prop="operationActionName" label="类型" width="80" />
          <el-table-column prop="source" label="来源" width="80" /> 
          <el-table-column prop="operationContent" label="操作内容" min-width="250" show-overflow-tooltip />
          
        </el-table>
      </div>
    </page-list-container>
  </div>
</template>

<script>
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import { DateTool } from "@js/date-tool.js";
import { Table, TableColumn } from 'element-ui';
import dayjs from "dayjs";

export default {
  components: {
    PageListContainer,
    ElTable: Table,
    ElTableColumn: TableColumn,
  },

  props: {
    duration: {
      type: Object,
      default: () => ({ startTime: 0, endTime: 0 })
    }
  },

  data() {
    return {
      startTime: undefined,
      endTime: undefined,
      dataArray: [],
      total: 0,
      pageSize: undefined,
      currentPage: 1,
      tableHeight: window.innerHeight - 200,
    };
  },

  computed: {
    hospitalId() {
      return this.$store.state.selectedHospital.hospitalid;
    },
  },

  watch: {
    duration(value) {
      if (value && value.startTime && value.endTime) { 
        this.startTime = dayjs(value.startTime * 1000).format('YYYY-MM-DD HH:mm:ss');
        this.endTime = dayjs(value.endTime * 1000).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.startTime = undefined;
        this.endTime = undefined;
      }
      this.currentPage = 1;
      this.getLogList();
    },
    hospitalId() {
      this.currentPage = 1;
      this.getLogList();
    }
  },

  mounted() {
    this.pageSize = bestPageSizeComputer();
    this.getLogList();
    this.tableHeight = window.innerHeight - 200;
  },

  methods: {
    // 数据格式化方法
    placeholderText(rawValue) {
      if (!rawValue || rawValue === "null") {
        return "-";
      }
      return rawValue;
    },

    formatOperationTime(operationTime) {
      return this.placeholderText(
        DateTool.formatDate(
          DateTool.strToDate(operationTime),
          "Y-M-D h:m:s"
        )
      );
    },

    formatSource(source) {
      if (source === 0) {
        return "PC端";
      } else if (source === 1) {
        return "APP";
      }
      return "-";
    },

    // 搜索方法（兼容父组件调用）
    onSearchClick(keyword) {
      // 设备档案不需要关键字搜索，忽略此方法
    },

    // 分页
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.getLogList();
    },

    onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getLogList();
    },

    // 加载设备档案记录
    async getLogList() {
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          hospitalId: this.hospitalId,
        };

        // 添加时间范围
        if (this.startTime && this.endTime) {
          params.startTime = this.startTime;
          params.endTime = this.endTime;
        }

        // 调用getSleepOperationLogs接口获取设备档案操作日志
        const response = await this.$api.getSleepOperationLogs(params);
        this.dataArray = (response.list || []).map(item => ({
          operatorName: this.placeholderText(item.operatorName),
          operationTime: this.formatOperationTime(item.operationTime),
          operationActionName: this.placeholderText(item.operationActionName),
          operationContent: this.placeholderText(item.operationContent),
          source: this.formatSource(item.source),
          targetName: this.placeholderText(item.targetName),
        }));
        this.total = response.total;
      } catch (error) {
        console.error('获取设备档案记录失败:', error);
        this.$toast.showRed("获取设备档案记录失败");
        this.dataArray = [];
        this.total = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.equipment-records {
  font-size: 19px;
  width: 100%;
  
  &-table {
    display: flex;
    flex-direction: column;

    /deep/.el-table {
      font-size: 14px;
    }
    /deep/thead {
      th {
        background-color: #FAFAFA;
      }
    }
  }
}
</style>